import styled from '@emotion/styled';
import type { EntityEvent } from '@racemap/sdk/schema/entityEvents';
import type { StarterResult } from '@racemap/utilities/types/monitor';
import { type FC, Suspense } from 'react';
import { lazily } from '../../lib/lazily';
import { LoadingSpinner } from '../LoadingSpinner';

const { AlertStream } = lazily(() => import('./AlertStream/AlertStream'));
const { MonitorTable } = lazily(() => import('./MonitorTable'));

interface Props {
  selectedAlert: EntityEvent | null;
  onAlertSelection: (alert: EntityEvent | null) => void;
  showStream: boolean;
  filteredStarters: Array<StarterResult>;
}

export const MonitorTableAndStream: FC<Props> = ({
  filteredStarters,
  selectedAlert,
  showStream,
  onAlertSelection,
}) => {
  return (
    <Container>
      <Suspense fallback={<LoadingSpinner />}>
        <MonitorTable
          markedStarterId={selectedAlert?.entityId.toHexString() || null}
          starters={filteredStarters}
        />
        <div style={{ display: showStream ? 'flex' : 'none', paddingLeft: '15px' }}>
          <AlertStream
            selectedAlertId={selectedAlert?.id.toHexString() || null}
            onAlertClick={onAlertSelection}
          />
        </div>
      </Suspense>
    </Container>
  );
};

const Container = styled.div`
  margin: 0px 30px 5px 30px;
  display: flex;
  flex: 1;
  height: 100%;
`;
